/* eslint-disable no-irregular-whitespace */
import { ArticleParagraph2 } from '@cian/ui-kit';

import classNames from 'clsx';
import * as React from 'react';

import { BannerWrapper } from '../BannerWrapper';

import icon from './ocenka.svg';

import * as styles from './styles.css';

interface IRealtorReportBannerProps {
  onClose(): void;
  redirectUrl: string;
}

export const RealtorReportBanner: React.FC<IRealtorReportBannerProps> = props => {
  const { onClose, redirectUrl } = props;

  return (
    <BannerWrapper
      attributes={{
        className: classNames(styles['container']),
        'data-testid': 'realtor_report_banner',
      }}
      onClose={onClose}
    >
      <img alt="icon" src={icon} />
      <div className={styles['content']}>
        <ArticleParagraph2>Создайте отчёт об оценке и отправьте его клиенту</ArticleParagraph2>
        <a className={styles['link']} href={redirectUrl} rel="noreferrer" target="_blank">
          <ArticleParagraph2 color="text-main-default">Перейти к оценке</ArticleParagraph2>
        </a>
      </div>
    </BannerWrapper>
  );
};
